import React from "react";
import { Navbar, Container, Row, Col } from "react-bootstrap";
import { BaseWithNav } from "../RootLayout";
import * as Assets from "../../utils/svg_assets";
import { useNavigate } from "react-router-dom";
import "./style.scss";
import ApiUtils from "../../utils/api_utils";

const DetailLayout = ({
  children,
  bottomNavIndex = 1,
  show_menu = true,
  isCustom = false,
  headerImg,
  backPage,
  referenceData = "",
}) => {
  const navigate = useNavigate();

  const styleAfterRedeemed = {
    backgroundImage: `url(${ApiUtils.validateImgUrl({ url: headerImg })})`,
    filter: "brightness(60%)",
  };

  const defaultStyle = {
    backgroundImage: `url(${ApiUtils.validateImgUrl({ url: headerImg })})`,
  };

  return (
    <div id="detail-layout-base">
      <BaseWithNav index={bottomNavIndex} show_menu={show_menu}>
        <Container fluid className="vh-100 zeropm base">
          <>
            <div className="base-box">
              <div className="base-box-content">
                <div
                  className="detail-layout-header"
                  style={referenceData ? styleAfterRedeemed : defaultStyle}
                >
                  <div className="layout-header">
                    <Navbar>
                      <Container>
                        <Navbar.Brand
                          onClick={() => {
                            navigate(backPage);
                          }}
                        >
                          <img
                            src={Assets.iconBackWhite}
                            className="icon-back"
                            alt="arrow-back"
                          />
                        </Navbar.Brand>
                      </Container>
                    </Navbar>
                  </div>
                </div>
                {referenceData && (
                  <div className="reference">
                    <Row className="reference-code">
                      <Col>CODE {referenceData}</Col>
                    </Row>
                    <Row className="reference-by">
                      <Col>Powered By SKOR</Col>
                    </Row>
                  </div>
                )}
              </div>
            </div>
          </>
          <div
            className="base-box base-stack-top content-layout"
            style={{ marginTop: isCustom ? "25vh" : "18vh" }}
          >
            {children}
          </div>
        </Container>
      </BaseWithNav>
    </div>
  );
};

export default DetailLayout;
